"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type VideoItem = {
  title?: FieldConfig;
  slug?: string;
  imageSrc?: FieldConfig;
  timeAgo?: FieldConfig;
  authorName?: string;
  imageMetadata?: ImageMetadata;
};
type Props = {
  videos?: VideoItem[];
  imageMetadata?: ImageMetadata;
};
export default function HorizontalSmallVideoRightNews(t0) {
  const $ = _c(19);
  const {
    videos: t1,
    imageMetadata
  } = t0;
  let t2;
  let t3;
  if ($[0] !== imageMetadata || $[1] !== t1) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const videos = t1 === undefined ? [] : t1;
      if (videos.length === 0) {
        let t4;
        if ($[4] !== imageMetadata) {
          t4 = getFocusPointStyle(imageMetadata);
          $[4] = imageMetadata;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        let t5;
        if ($[6] !== t4) {
          t5 = <Image src={FALLBACK_IMAGE} alt="Default video thumbnail" fill={true} className="object-contain w-full h-full" style={t4} sizes="(min-width: 1024px) 200px, 100vw" loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} />;
          $[6] = t4;
          $[7] = t5;
        } else {
          t5 = $[7];
        }
        let t6;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <div className="absolute inset-0 flex items-center justify-center bg-000000/20 hover:bg-000000/30 transition-colors" />;
          $[8] = t6;
        } else {
          t6 = $[8];
        }
        let t7;
        if ($[9] !== t5) {
          t7 = <div className="w-[120px] h-[85px] lg:w-[130px] lg:h-[100px] xl:w-[150px] xl:h-[112px] flex-shrink-0"><div className="relative w-full h-full overflow-hidden">{t5}{t6}</div></div>;
          $[9] = t5;
          $[10] = t7;
        } else {
          t7 = $[10];
        }
        let t8;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = <div className="flex flex-col gap-2"><div className="text-11-tamil-600 text-012061 tracking-wide uppercase">வீடியோக்கள்</div><h3 className="text-1B1B1B text-14-tamil-700 leading-[1.4]">தினமணி வீடியோக்கள்</h3><p className="text-4D4D4D text-12-english-400 line-clamp-2">சமீபத்திய வீடியோக்கள் விரைவில்...</p></div>;
          $[11] = t8;
        } else {
          t8 = $[11];
        }
        let t9;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
          t9 = <div className="flex flex-col justify-between gap-2 lg:min-h-[134px] flex-1 min-w-0">{t8}<div className="flex items-center justify-between"><span className="text-12-tamil-500 text-1B1B1B">இப்போது</span><MessageIcon id="video-news-message-icon" category={BOOKMARK_CATEGORIES.VIDEOS} title={"\u0BA4\u0BBF\u0BA9\u0BAE\u0BA3\u0BBF \u0BB5\u0BC0\u0B9F\u0BBF\u0BAF\u0BCB\u0B95\u0BCD\u0B95\u0BB3\u0BCD"} thumbnailUrl={FALLBACK_IMAGE} /></div></div>;
          $[12] = t9;
        } else {
          t9 = $[12];
        }
        let t10;
        if ($[13] !== t7) {
          t10 = <article className="overflow-hidden p-4"><div className="flex flex-row-reverse gap-4">{t7}{t9}</div></article>;
          $[13] = t7;
          $[14] = t10;
        } else {
          t10 = $[14];
        }
        t3 = t10;
        break bb0;
      }
      let t4;
      if ($[15] !== imageMetadata) {
        t4 = (video, index) => {
          const titleValue = video.title?.value || "";
          const imageSrcValue = getImageUrl(video.imageSrc?.value) || FALLBACK_IMAGE;
          getTimeAgo(video.timeAgo?.value);
          return <Link key={`${video.slug}-${index}`} href={`/${video.slug}`} className="block  transition-colors cursor-pointer"><article className="overflow-hidden p-4 border-b border-DCDCDC"><div className="flex flex-row-reverse gap-4">{!video.imageSrc?.hidden && <div className={`w-[120px] h-[85px] lg:w-[130px] lg:h-[100px] xl:w-[150px] xl:h-[112px] flex-shrink-0 ${video.imageSrc?.customClass || ""}`}><div className="relative w-full h-full overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} className="object-contain w-full h-full" style={getFocusPointStyle(video.imageMetadata ?? imageMetadata)} sizes="(min-width: 1024px) 200px, 100vw" loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /><div className="absolute inset-0 flex items-center justify-center bg-000000/20 hover:bg-000000/30 transition-colors" /></div></div>}<div className="flex flex-col justify-between gap-2 lg:min-h-[134px] flex-1 min-w-0"><div className="flex flex-col gap-2">{!video.title?.hidden && <h3 className={`text-1B1B1B text-14-tamil-700 md:text-12-tamil-600 leading-[1.4] ${video.title?.customClass || ""}`}>{titleValue}</h3>}</div><div className="flex items-center justify-between"><MessageIcon id={`video-news-message-icon-${index}`} slug={video.slug} category={BOOKMARK_CATEGORIES.VIDEOS} title={titleValue} thumbnailUrl={imageSrcValue} articleUrl={`/${video.slug}`} /></div></div></div></article></Link>;
        };
        $[15] = imageMetadata;
        $[16] = t4;
      } else {
        t4 = $[16];
      }
      t2 = videos.slice(0, 4).map(t4);
    }
    $[0] = imageMetadata;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[17] !== t2) {
    t4 = <>{t2}</>;
    $[17] = t2;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}